<template>
    <div v-if="isLoaded">
        <div class="content-body" v-bind:class="{ fullscreen_expand: isFullscreen }">
            <div class="row match-height">
                <div class="col-xl-12 col-lg-12">
                    <div class="card" style="">
                        <div class="card-header">
                            <h4 class="card-title">Porto</h4>
                            <a class="heading-elements-toggle"><i class="fa fa-ellipsis-v font-medium-3" @click="setSubMenuShowHideFw(getSubMenuShowHideFw())"></i></a>
                            <div class="heading-elements"  v-bind:class="{ visible: getSubMenuShowHideFw(), '': !getSubMenuShowHideFw() }">
                                <ul class="list-inline mb-0">
                                    <li><a @click="onCreate()" v-b-tooltip title="Cadastrar" v-if="getPermissionFw('porto.store')"><i class="fa fa-plus"></i></a></li>
                                    <li><a @click="onFilterReset()" v-b-tooltip title="Atualizar listagem"><i class="ft-rotate-cw"></i></a></li>
                                    <li><a @click="expandFullscreenFw()" v-b-tooltip title="Expande a tela" v-if="!isFullscreen"><i class="ft-maximize"></i></a></li>
                                    <li><a @click="expandFullscreenFw()" v-b-tooltip title="Minimiza a tela" v-if="isFullscreen"><i class="ft-minimize"></i></a></li>
                                    <li><a @click="onFilterShowHideFw()" v-b-tooltip.hover.left="'Filtros'"><i class="fa fa-filter"></i></a></li>
                                    <li><a @click="onActivateDesactivate(1, null, false)" v-b-tooltip title="Ativar Registros"  v-if="getPermissionFw('porto.status')"><i class="fa fa-thumbs-o-up"></i></a></li>
                                    <li><a @click="onActivateDesactivate(2, null, false)" v-b-tooltip title="Inutilizar Registros"  v-if="getPermissionFw('porto.status')"><i class="fa fa-thumbs-o-down"></i></a></li>
                                </ul>
                            </div>
                        </div>
                    <div class="card-content">
                        <div class="table-responsive">
                            <div v-if="vuetableFilterRow">
                                <vuetable-filterbar :tabela="'param_banco'">
                                </vuetable-filterbar>
                            </div>
                        <div class="loadingDataPosition">
                            <div class="loadingData" v-if="loadingData"><div class="loadingDataSpinner"><spinner v-if="loadingData" text-fg-color="#ffffff" message="Carregando..."></spinner></div></div>
                            <vuetable ref="vuetable"
                                    api-url="/api/porto"
                                    :fields="fields"
                                    :css="css"
                                    :append-params="moreParams"
                                    track-by="porto_id"
                                    pagination-path=""
                                    @vuetable:load-error="onError"
                                    detail-row-component="porto-detalhes"
                                    @vuetable:cell-clicked="onDetail"
                                    @vuetable:pagination-data="onPaginationData"
                                    @vuetable:loaded="onLoaded"
                                  >
                                  <template slot="status" slot-scope="props">
                                      <span class="badge badge-success" v-if="props.rowData.status.valor==1">{{ props.rowData.status.descr }}</span>
                                      <span class="badge badge-danger" v-if="props.rowData.status.valor==2">{{ props.rowData.status.descr }}</span>
                                    </template>
                                  <template slot="actions" slot-scope="props">
                                    <div class="custom-actions">
                                        <a @click="onEdit(props.rowData, props.rowIndex)" v-if="getPermissionFw('porto.update')" v-b-tooltip title="Editar"><i class="fa fa-edit"></i></a>
                                        <div v-if="getPermissionFw('porto.status')">
                                            <a v-if="props.rowData.status.valor==2" @click="onActivateDesactivate(1, props.rowData, true)" v-b-tooltip title="Ativar"><i class="fa fa-thumbs-o-up"></i></a>
                                            <a v-if="props.rowData.status.valor==1" @click="onActivateDesactivate(2, props.rowData, true)" v-b-tooltip title="Inativar"><i class="fa fa-thumbs-o-down"></i></a>
                                        </div>
                                        <a v-if="getPermissionFw('porto.terminal.store')" @click="onCreateTerminal(props.rowData)" v-b-tooltip title="Vincular Terminal"><i class="fa fa-anchor"></i></a>
                                        <a @click="onDetail(props.rowData, null, null)" v-b-tooltip title="Ver detalhes"><i class="fa fa-plus"></i></a>
                                      </button>
                                    </div>
                                  </template>

                            </vuetable>
                        </div>
                    <div>
                        <div class='col-md-12'>
                            <div class="pull-left pagination-detail">
                                <vuetable-pagination-info ref="paginationInfo"
                                                          :css="css.pagination"
                                                          info-class="pull-left"
                                ></vuetable-pagination-info>
                            </div>
                            <div class="pull-right m-a-0">
                                <vuetable-pagination ref="pagination"
                                                     :css="css.pagination"
                                                     @vuetable-pagination:change-page="onChangePage"
                                ></vuetable-pagination>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
<PortoForm
    ref="portoform" :metodo="onFilterReset" :tabela="'porto'" :rota="'porto'">
</PortoForm>
<TerminalForm
    ref="terminalform">
</TerminalForm>
              </div>
          </div>
</template>
<script>
import Vuetable from '../components/Vuetable'
import VuetablePagination from '../components/VuetablePagination'
import VuetablePaginationInfo from '../components/VuetablePaginationInfo'
import PortoFilterBar from './PortoFilterBar'
import PortoForm from './PortoForm'
import TerminalForm from './TerminalForm'
import PortoDetalhes from './PortoDetalhes'

Vue.component('porto-detalhes', PortoDetalhes);

export default {
    components: {
        Vuetable,
        VuetablePagination,
        VuetablePaginationInfo,
        PortoForm,
        TerminalForm,
        'vuetable-filterbar': PortoFilterBar,
    },
    data () {
        return {
          modal_titulo: '',
          modal_botao: '',
          modal_acao: '',
          loading: false,
          isDisabled: false,
          loadingData: true,
          showModal: false,
          showModalTerminal: false,
          optionsLivStatus: [],
          optionsLivStatusTerminal: [],
          optionsMunicipio: [],
          activateDesativate: [],
          helpForm: new Form({statusRecord: [], params: []}),
          form: new Form({
                    cd: '',
                    nome: '',
                    cd_erp: '',
                    porto_id: '',
                    status: [],
                    municipio: []
                }),
          formterminal: new Form({
                    cd: '',
                    descr: '',
                    cd_erp: '',
                    cd_antaq: '',
                    porto_id: '',
                    terminal_id:'',
                    status: []
                }),
          fields: [
            {
              name: '__checkbox',
              titleClass: 'center aligned',
              dataClass: 'center aligned'
            },
            {
              name: 'cd',
              title: 'Código',
              sortField: 'cd'
            },
            {
              name: 'cd_erp',
              title: 'Código ERP',
              sortField: 'cd_erp'
            },
            {
              name: 'nome',
              title: 'Nome',
              sortField: 'nome'
            },
            {
              name: 'municipio.nome',
              title: 'Município',
              sortField: 'municipio'
            },
            {
              name: '__slot:status',
              title: 'Status',
              sortField: 'status'
            },
            {
              name: '__slot:actions',
              title: 'Ações',
              titleClass: 'center aligned',
              dataClass: 'center aligned'
            }
        ],
        css: {
            tableClass: 'table table-striped',
            loadingClass: 'loading',
            ascendingIcon: 'glyphicon glyphicon-chevron-up',
            descendingIcon: 'glyphicon glyphicon-chevron-down',
            handleIcon: 'glyphicon glyphicon-menu-hamburger',
        },
        moreParams: {}
       }
    },
mounted() {
    this.$events.$on('filter-set', eventData => this.onFilterSet(eventData));
    this.$events.$on('filter-reset', e => this.onFilterReset());
    this.getLivGeral();

  },
methods: {
    onPaginationData (paginationData) {
      this.$refs.pagination.setPaginationData(paginationData)
      this.$refs.paginationInfo.setPaginationData(paginationData)
    },
    onChangePage (page) {
      this.$refs.vuetable.changePage(page)
    },
    onFilterSet (data_filter) {
        this.loadingData = true;
        this.moreParams = {
            'cd':  data_filter.cd,
            'cd_erp':  data_filter.cd_erp,
            'nome': data_filter.nome.value,
            'municipio': data_filter.municipio.value

        }
        Vue.nextTick( () => {this.$refs.vuetable.reload(); })
    },
    onFilterReset () {
        this.loadingData = true;
        this.moreParams = {}
        Vue.nextTick( () => this.$refs.vuetable.refresh())
    },
    onLoaded: function () {
        this.dataExport = this.$refs.vuetable.tableData;
        this.loadingData = false;
        this.$store.commit('setVuetableFilterButton', false);
    },
    onDetail (data, field, event) {
        this.$refs.vuetable.toggleDetailRow(data.porto_id);
    },
    onCreate ()
    {
      this.$refs.portoform.onCreate();
    },
    onEdit (data, index)
    {
      this.id = data.porto_id;
      this.$refs.portoform.onEdit(data, index, this.id);
    },
    onCreateTerminal (data)
    {
      this.$refs.terminalform.onCreateTerminal(data);
    },
    onEditTerminal (data, index)
    {
      this.id = data.porto_id;
      this.$refs.terminalform.onEditTerminal(data, index, this.id);
    },
    getLivGeral()
    {
        this.helpForm.get('/api/porto/jsonlistgeral').then(response =>
        {
            new ReturnApi(response, this, true, false, false);
            response.status.forEach((obj)=>
            {
                this.optionsLivStatus.push({ text: obj.descr, value: obj.valor })
            })
            response.status_terminal.forEach((obj)=>
            {
                this.optionsLivStatusTerminal.push({ text: obj.descr, value: obj.valor })
            })
            response.municipio.forEach((obj)=>
            {
                this.optionsMunicipio.push({ label: obj.nome, value: obj.municipio_id })
            })

        })
        .catch(errors =>
        {
            new ReturnApi(errors, this)
        });
    },
    onActivateDesactivate(action, data, tipo)
    {
        // Tipo = true = Checkbox
        if(tipo)
        {
            this.helpForm.statusRecord = [];
            this.helpForm.statusRecord.push({ id: data.porto_id, status: action });
        }
        else
        {
            this.helpForm.statusRecord = [];
            this.$refs.vuetable.selectedTo.forEach((obj)=>{
                this.helpForm.statusRecord.push({ id: obj, status: action })
            });
        }
        this.$refs.portoform.onActivateDesactivate(this.helpForm);
    },
    onError(response) {
        new ReturnApi(response.response, this, true, true, false);
    },
},
computed: {
    vuetableFilterRow: {
      get () {
        return this.$store.state.vuetable.filterRow;
      },
    },
    isLoaded: {
        get() {
            return this.$store.getters.isloaded;
        }
    },
    isFullscreen: {
        get() {
            return this.$store.getters.is_full_screen;
        }
    }
}
}
</script>
